jQuery(document).ready(function ($) {
  'use strict'

  var $body = $('body')
  var $site_overlay = $('.site-overlay')
  var $mobile_menu = $('.main-navigation')

  // region Mobile Menu
  $('.mobile-menu-button').on('click', function (e) {
    $body.toggleClass('menu-in')
    $('.mobile-menu-button .btn').toggleClass('active')
    $mobile_menu.toggleClass('visible')
  })

  $site_overlay.on('click', function () {
    $body.toggleClass('menu-in')
    $('.mobile-menu-button .btn').toggleClass('active')
    $mobile_menu.toggleClass('visible')
  })
  // endregion

  // region Speakers
  $('.wrap-speakers article').on('click', function () {
    $('div.speaker-helper').remove()
    $('.speaker.active').not(this).removeClass('active')

    var $parent = $(this).parent()
    var height = $(this).height()
    $(this).toggleClass('active')

    if ($(this).hasClass('active')) {
      $('<div>', {
        class: 'speaker-helper',
        style: 'height:' + height + 'px'
      }).appendTo($parent)
    }
  })
  // endregion

  // region Schedule
  $('.wrap-schedule .title.linked').on('click', function () {
    var $article = $(this).parents('.article-item')
    $('#schedule-modal #modal-title').text($article.find('.article-title').text())
    $('#schedule-modal .modal-body').html($(this).parent().clone())
    $('#schedule-modal').modal('show')
  })

  $('.wrap-schedule .article-title').on('click', function () {
    var $article = $(this).parents('.article-item')
    $('#schedule-modal #modal-title').text($article.find('.article-title').text())
    $('#schedule-modal .modal-body').html($article.find('.article-content').html())
    $('#schedule-modal').modal('show')
  })
  // endregion
})
